/**
 * @generated SignedSource<<339174bab23edc10eebd7596cb51812e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerOnelineMenuAppConfigQuery$data = {
  readonly onelineMenu: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "headerOnelineMenuAppConfigQuery";
};
export type headerOnelineMenuAppConfigQuery$key = {
  readonly " $data"?: headerOnelineMenuAppConfigQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerOnelineMenuAppConfigQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerOnelineMenuAppConfigQuery",
  "selections": [
    {
      "alias": "onelineMenu",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "scmp_pwa_oneline_menu"
          }
        }
      ],
      "concreteType": "AppConfig",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_oneline_menu\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "225aa6c7594c335c9836d49ef06b80ef";

export default node;
